var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sidebar-offcanvas",class:{ open: _vm.selectorStore.displayFilter }},[_c('FilterContent',{attrs:{"car-count":_vm.carCount},on:{"filterChanged":_vm.onFilterChanged}}),_c('FilterActions',{attrs:{"car-count":_vm.carCount},on:{"deleteFilter":_vm.onDeleteFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }